// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EditDocument-module__buttons--1cdVf","loading":"EditDocument-module__loading--1lwi8"};